import React from 'react';
import { Box } from '@mui/material';
import { Link } from 'react-router-dom';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  // Kept for API compatibility. The logo art already contains the "Debtornator"
  // wordmark, so we never render separate text alongside it (avoids the duplicate).
  showText?: boolean;
}

const Logo: React.FC<LogoProps> = ({ size = 'medium' }) => {
  const heights = { small: 44, medium: 56, large: 72 };

  return (
    <Box
      component={Link}
      to="/"
      sx={{ display: 'inline-flex', alignItems: 'center', textDecoration: 'none' }}
      aria-label="Debtornator home"
    >
      <Box
        component="img"
        src="/debtornator_logo_dark.png"
        alt="Debtornator"
        sx={{
          height: heights[size],
          width: 'auto',
          // The art is a solid black wordmark; render it white for the dark UI.
          filter: 'brightness(0) invert(1)',
        }}
      />
    </Box>
  );
};

export default Logo;
